import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { TextM, TextMS, TextSS } from "../../common/text";
import { registerAtom } from "../../recoil/atoms";
import DetailPageLayout from "../Layout/DetailPageLayout";
import {
  useSendEmail,
  useValidateEmail,
} from "./RegisterValidateEmail.helpers";
import {
  NextButton,
  Header,
  RegisterWrapper,
  ContentContainer,
  ResendButton,
  Input,
  NextButtonText,
} from "./RegisterValidateEmail.styles";
import { useReloadWarning } from "../../common/hooks";

const RegisterValidateEmail = () => {
  const { username, emailMessage } = useRecoilValue(registerAtom);

  const [input, setInput] = useState(""); // 사용자의 인증번호 입력
  const [isValidInput, setIsValidInput] = useState(false); // 사용자 입력 유효성

  const { mutate: sendEmail } = useSendEmail(); // 이메일 발송 훅
  const { mutate: validateEmail } = useValidateEmail(); // 이메일 인증 훅

  // 마운트되면서 이전 화면에서 입력한 이메일로 인증메일 발송
  useEffect(() => {
    sendEmail(username);
  }, []);

  useReloadWarning(); // 새로고침 경고 발생 훅

  // 다음 버튼 눌렀을때
  const onClickValidateEmail = () => {
    const data = {
      username,
      authenticationNumber: input,
    };

    validateEmail(data);
  };

  // 사용자의 인증번호 입력 핸들러
  const onInputChange = (currentInput) => {
    setInput(currentInput);
    if (currentInput.length === 6) {
      setIsValidInput(true); // 6자리일때
    } else {
      setIsValidInput(false);
    }
  };

  return (
    <DetailPageLayout headerText={"이메일 인증"}>
      <ContentContainer>
        <Header>
          <TextMS>{username}</TextMS>
          <TextM>전송된 인증번호를 입력해주세요</TextM>
        </Header>
        <RegisterWrapper>
          <Input
            value={input}
            onChange={onInputChange}
            numInputs={6}
            isInputNum
            inputStyle={{
              border: "0",
            }}
            focusStyle={{
              border: "0",
              outline: "none",
            }}
          />
          <TextSS color="#f44b59">{emailMessage}</TextSS>
          <TextMS>인증번호를 받지 못하셨나요?</TextMS>
          <ResendButton onClick={() => sendEmail(username)}>
            <TextMS color="#f44b59">재전송</TextMS>
          </ResendButton>
        </RegisterWrapper>

        <NextButton onClick={onClickValidateEmail} isValidInput={isValidInput}>
          <NextButtonText isValidInput={isValidInput}>다음</NextButtonText>
        </NextButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default RegisterValidateEmail;

//  const [time, setTime] = useState(300);

// <TextM>
// {parseInt(time / 60)} : {getSeconds(time)}
// </TextM>

// const getSeconds = (time) => {
//   const seconds = Number(time % 60);
//   if (seconds < 10) {
//     return "0" + String(seconds);
//   } else {
//     return String(seconds);
//   }
// };

// useEffect(() => {
//   const timer = setInterval(() => {
//     setTime((prev) => prev - 1);
//   }, 1000);
//   return () => clearInterval(timer);
// }, [time]);

// if (time < 0) {
//   alert("인증시간이 초과되었습니다. 초기 화면으로 이동합니다.");
//   window.location.href = "/login";
// }
